export function createCompareFunction<T extends NonNullable<unknown>>(property: keyof T, sortOrder: 'ASC' | 'DESC') {
	return (a: T, b: T) => {
		const left: T[keyof T] = a[property];
		const right: T[keyof T] = b[property];
		const order = sortOrder !== 'DESC' ? 1 : -1;
		switch (typeof left) {
			case 'number': {
				const rightAsNumber = right as number;
				const result = left - rightAsNumber;
				return result * order;
			}
			case 'string': {
				const rightAsString = right as string;
				const result = left.localeCompare(rightAsString);
				return result * order;
			}
			default:
				return 0;
		}
	};
}
